import { render, staticRenderFns } from "./learn-more.vue?vue&type=template&id=d7e911fe"
import script from "./learn-more.vue?vue&type=script&lang=js"
export * from "./learn-more.vue?vue&type=script&lang=js"
import style0 from "./learn-more.vue?vue&type=style&index=0&id=d7e911fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/usr/src/app/components/tf/img.vue').default})
